var map = {
	"./peitu-1.png": 547,
	"./peitu-2.png": 553,
	"./peitu-3.png": 554,
	"./peitu-4.png": 555,
	"./peitu-5.png": 556,
	"./peitu-6.png": 557
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 552;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ecDeal ^\.\/peitu\-.*\.png$
// module id = 552
// module chunks = 12